module.exports = __webpack_public_path__ + "static/media/S23-0447_ChickenCrunchers_Homepage_Website_Desktop_2396x1473.d07369ae.jpg";